import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { FromWebRecipePage } from "./-FromWebRecipePage";

// `?url=` lets a bookmarklet or share sheet deep-link straight into an import.
const fromWebSearchSchema = z.object({
  url: z.string().optional(),
});

export const Route = createFileRoute("/_app/_recipe-page/recipes/from-web")({
  validateSearch: (search): { url?: string } =>
    fromWebSearchSchema.parse(search),
  component: () => <FromWebRecipePage initialUrl={Route.useSearch().url} />,
});
